import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminLogin from '../admin/AdminLogin';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <AdminLogin />;
};

export default ProtectedRoute;